import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export const PLAYERS = {
  1: {
    id: 1,
    name: 'Player 1',
    color: '#8B5CF6', // violet-500
    colorClass: 'bg-violet-500',
    textClass: 'text-violet-500',
    borderClass: 'border-violet-500',
    pattern: 'diagonal-stripes',
  },
  2: {
    id: 2,
    name: 'Player 2',
    color: '#14B8A6', // teal-500
    colorClass: 'bg-teal-500',
    textClass: 'text-teal-500',
    borderClass: 'border-teal-500',
    pattern: 'dots',
  },
}

export const BOARD_LAYOUT = [
  [1, 2, 3, 4, 5, 6],
  [7, 8, 9, 10, 12, 14],
  [15, 16, 18, 20, 21, 24],
  [25, 27, 28, 30, 32, 35],
  [36, 40, 42, 45, 48, 49],
  [54, 56, 63, 64, 72, 81],
]
